import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';

import { MainContainerQueryProvider } from 'bdvp-common/src/contexts/mainContainerQuery';
import useNodeQuery from 'bdvp-common/src/hooks/useNodeQuery';
import { cqClassPrepend, wrapperClass } from 'bdvp-common/src/styles/helpers/main-cq';

const Wrapper = styled.section`
    flex: 1 1 auto;
    color: ${COLORS.mlbWhite};
    width: calc(100% - ${({ theme }) => theme?.filter?.width });
`;

const Content = ({
    children,
}) => {

    const [
        matches,
        ref,
    ] = useNodeQuery();

    let className = wrapperClass;

    for (const size in matches) {

        if (matches[size]) {

            className += ` ${cqClassPrepend}${size}`;

        }

    }

    return (
        <Wrapper ref={ref} className={className}>
            <MainContainerQueryProvider matches={matches}>
                {children}
            </MainContainerQueryProvider>
        </Wrapper>
    );

};

Content.propTypes = {
    children: PropTypes.element.isRequired,
};

export default Content;
